import {
  type PimProductV11,
  type PimProductV1Flags,
} from '@redteclab/api/clients/bully'

import {
  RECOMMENDATION_WIDGET_BUY_TOGETHER,
  type RecommendationWidgetType,
} from '../../../recommendation'
import { TENANT } from '../../../tenant'

/**
 * We don't have per-tenant recommendation configuration, so exception flags are kept here.
 */
type FlagsPerTenant = Partial<
  Record<RecommendationWidgetType, (keyof PimProductV1Flags)[]>
> | null

const RECOMMENDATION_EXCEPTION_FLAGS: Partial<Record<TENANT, FlagsPerTenant>> =
  {
    [TENANT.IT]: {
      [RECOMMENDATION_WIDGET_BUY_TOGETHER]: ['medicament'],
    },
  }

export const recommendationAccessorIsExceptionFlagActiveInProduct = ({
  area,
  currentVariant,
  tenant,
}: {
  area: RecommendationWidgetType
  currentVariant: PimProductV11
  tenant: TENANT
}): boolean => {
  const exceptionFlagsForArea = RECOMMENDATION_EXCEPTION_FLAGS[tenant]?.[area]

  return Boolean(
    exceptionFlagsForArea?.some((flag) => currentVariant.flags?.[flag]?.active),
  )
}
